import { render, staticRenderFns } from "./Splint.vue?vue&type=template&id=4fe25866&"
import script from "./Splint.vue?vue&type=script&lang=js&"
export * from "./Splint.vue?vue&type=script&lang=js&"
import style0 from "./Splint.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports